import {Component, Input, OnInit} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {SelectComponent} from 'web-shared';
import {ItemQuery} from 'web-shared';
import {ManufacturingItemEditModalComponent} from '../manufacturing-item-edit-modal/manufacturing-item-edit-modal.component';
import {ItemGroupsQuery} from 'web-shared';
import {ManufacturingItemGroupEditModalComponent} from '../../manufactured-item-groups/manufacturing-item-group-edit-modal/manufacturing-item-group-edit-modal.component';
import {filter, map, switchMap, takeUntil} from "rxjs/operators";
import {concat, distinctUntilChanged, Observable, of, Subject} from "rxjs";

@Component({
  selector: 'mes-web-manufacturing-item-select',
  templateUrl: './manufacturing-item-select.component.html',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ManufacturingItemSelectComponent extends SelectComponent<ItemQuery> implements OnInit {
  searchInput$ = new Subject<string>();

  filteredItems$: Observable<ItemQuery[]>;
  constructor(private itemGroupsQuery: ItemGroupsQuery) {
    super();
  }

  addNew(searchTerm: string = null) {
    this.modalService.show(ManufacturingItemEditModalComponent, {initialState: {entityName: searchTerm} as ManufacturingItemEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
      const comp = bsModalRef.content as ManufacturingItemEditModalComponent;
      if (comp.entityId) {
        this.setEntityId(comp.entityId);
      }
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.filteredItems$ = concat(
      this.allItems$,
      this.searchInput$.pipe(
        distinctUntilChanged(),
        switchMap(term => {
          return this.allItems$.pipe(map(value => {
            return value.filter(value1 => this.searchFn(term, value1))
          }))
        })
      )
    );
  }

  editExisting(item: ItemQuery = null) {
    let masterItemId: string = null;
    this.entityId = item ? item.Id : this.entityId;
    this.allItems$.pipe(takeUntil(this.componentDestroyed)).subscribe((values: ItemQuery[]) => {
      const itemQuery = values.find(value => value.Id === this.entityId);
      if (itemQuery?.Code === this.itemGroupsQuery.getEntity(itemQuery.ItemGroupId).Code) {
        masterItemId = itemQuery.ItemGroupId;
      }
    });

    if (masterItemId) {
      this.modalService.show(ManufacturingItemGroupEditModalComponent, {initialState: {entityId: masterItemId} as ManufacturingItemGroupEditModalComponent, class: 'modal-xl'});
    } else {
      this.modalService.show(ManufacturingItemEditModalComponent, {initialState: {entityId: this.entityId} as ManufacturingItemEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
        const comp = bsModalRef.content as ManufacturingItemEditModalComponent;
        if (comp.entityId) {
          this.setEntityId(comp.entityId);
        }
      });
    }
  }

  onSelectionChanged($event: ItemQuery[] | ItemQuery) {
    if (this.multiple) {
      const items = $event as ItemQuery[];
      if (items && items.length) {
        this.entityIdsChange.emit(items.map(value => value.Id));
      } else {
        this.entityIdsChange.emit([]);
      }
    } else {
      this.setEntityId(($event as ItemQuery)?.Id);
    }
  }
}
